<template>
  <el-drawer title="费用详情" :visible.sync="drawer" destroy-on-close :wrapperClosable="false" custom-class="widthCommon">
    <el-form v-if="drawer" status-icon :model="editForm" label-width="120px" size="small" class="bg-#fff mx-20 pr-30 py-20">
      <div class="form-Title" style="display: flex; justify-content: space-between">业主信息</div>
      <el-form-item label="所属项目：">
        {{ getCommunityName(editForm.communityId) }}
      </el-form-item>
      <el-form-item label="所属车场：">{{ editForm.parkingName || '-' }}</el-form-item>
      <el-form-item label="车位编号：">
        {{ editForm.parkingSpaceName }}
      </el-form-item>
      <el-form-item label="业主姓名：">{{ editForm.ownerName || '-' }}</el-form-item>
      <el-form-item label="联系方式：">{{ editForm.ownerPhone || '-' }}</el-form-item>
      <div class="form-Title" style="margin-top: 30px; display: flex; justify-content: space-between">费用信息</div>
      <el-form-item label="收费科目：">{{ editForm.itemName || '-' }}</el-form-item>
      <el-form-item label="计费开始：">
        {{ editForm.chargeBeginDate || '-' }}
      </el-form-item>
      <el-form-item label="计费结束：">
        {{ editForm.chargeEndDate || '-' }}
      </el-form-item>
      <el-form-item label="应收金额：">{{ keepTwoDecimal(editForm.orderAmount) }}</el-form-item>
      <el-form-item label="费用说明：">
        {{ editForm.feeDescription || '-' }}
      </el-form-item>
      <el-form-item label="欠费时长：">{{ editForm.overdueTime || 0 }}天</el-form-item>
      <el-form-item label="账单生成时间：">
        {{ editForm.createTime || '-' }}
      </el-form-item>
    </el-form>
  </el-drawer>
</template>

<script>
export default {
  inject: ['indexThis'],
  data() {
    return {
      drawer: false,
      editForm: {
        communityId: '',
        parkingName: '',
        parkingSpaceName: '',
        ownerName: '',
        ownerPhone: '',
        itemName: '',
        chargeBeginDate: '',
        chargeEndDate: '',
        orderAmount: '',
        feeDescription: '',
        overdueTime: '',
        createTime: '',
      },
    }
  },
}
</script>
